import React from 'react'
 
 
const LOGO = () => {
  return (
    <div className='logo'>
 
      <img src="logo.png" alt = "lekeo.pl" />

</div>


    
  )
}
export default LOGO

 